<div *ngIf="inputShowSearch" class="search-wrapper">
    <div *ngIf="isTreeDisabled" class="searchDisabled"></div>
    <terra-text-input
        *ngIf="inputShowSearch"
        [inputName]="'terraNodeTree.search' | translate: _locale.language"
        [formControl]="_formControl"
    >
    </terra-text-input>
</div>
<ul class="terra-node-tree">
    <div *ngIf="isTreeDisabled" class="isDisabled"></div>
    <ng-container *ngFor="let node of inputConfig?.list">
        <terra-node *ngIf="node.isVisible" [inputNode]="node" [inputConfig]="inputConfig"> </terra-node>
    </ng-container>
</ul>
